// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"57e95f99","453":"00ec61d6","667":"7cab2173","977":"21a625db"}[chunkId] + ".chunk.js";
};